import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { IconHomeLine } from '@pentabd/icons';
import { TopBar } from '@pentabd/ui';

import { ROUTES } from '@constants/routes';
import RightSideNavMenu from '@components/RightSideNavMenu';
import { ReactComponent as KopotLogo } from '@images/kopot.svg';
import { useCustomParams } from '@hooks/useCustomParams';

type Props = {
  electionScheduleName: string;
  openElectionModalHandler: () => void;
};

const CandidateInfoTopbar = ({
  electionScheduleName,
  openElectionModalHandler,
}: Props) => {
  const { t } = useTranslation();

  const { searchParams } = useCustomParams();

  const leftNavMenu = [
    {
      icon: <IconHomeLine size="24" fill="subtitle2" />,
      name: t('HEADER.MENU_LIST.HOME'),
      child: `${
        searchParams.has('election_schedule_id')
          ? `${ROUTES.HOME}?election_schedule_id=${searchParams.get(
              'election_schedule_id',
            )}`
          : ROUTES.HOME
      }`,
    },
    {
      name: t('HEADER.MENU_LIST.CONSTITUENCY_WISE_RESULTS'),
      child: {
        leftSubMenus: [
          {
            name: t('CONSTITUENCY_WISE_RESULTS.HEADER.TEXT'),
            url: `${
              searchParams.has('election_schedule_id')
                ? `${
                    ROUTES.CONSTITUENCY_WISE_RESULT
                  }?election_schedule_id=${searchParams.get(
                    'election_schedule_id',
                  )}`
                : ROUTES.CONSTITUENCY_WISE_RESULT
            }`,
          },
          {
            name: t('CONSTITUENCY_WISE_RESULTS.HEADER.REPORT'),
            url: `${
              searchParams.has('election_schedule_id')
                ? `${
                    ROUTES.CONSTITUENCY_WISE_REPORT
                  }?election_schedule_id=${searchParams.get(
                    'election_schedule_id',
                  )}`
                : ROUTES.CONSTITUENCY_WISE_REPORT
            }`,
          },
        ],
      },
    },
  ];

  const brand = {
    icon: <KopotLogo />,
    link: '#',
  };

  const userDetails = {
    name: '',
    component: (
      <RightSideNavMenu
        electionScheduleName={electionScheduleName}
        openElectionModalHandler={openElectionModalHandler}
      />
    ),
  };

  return (
    <div id="customTopBar">
      <TopBar
        brand={brand}
        leftNavMenu={leftNavMenu}
        userDetails={userDetails}
        Link={Link}
        dropdownMenu
        bgColor="bg-light"
      />
      <div className="border border-danger">ddff</div>
    </div>
  );
};

export default CandidateInfoTopbar;
